<template>
  <v-app>
    <v-main class="app noselect">
      <div class="sticky-header">
        <div class="text-h6 text-truncate primary--text">GBLA Loop</div>
        <div class="d-flex justify-space-between">
          <div>
            <div style="width: 178px; margin-top: 0px">
              <v-select
                :items="listTanggal"
                item-text="Title"
                item-value="Id"
                label="Tanggal"
                solo
                dense
                hide-details="auto"
                @change="onDateChange"
                v-model="date"
              >
                <template slot="item" slot-scope="data" title="GBLA Race">
                  {{ data.item.Title }}
                  <span v-if="data.item.IsRace" class="select-flag">🏁</span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="text-truncate">
            <div class="text-caption text--secondary">Jarak</div>
            <div>
              51.19
              <span class="text-caption text--secondary">km</span>
            </div>
          </div>
          <div class="text-truncate">
            <div class="text-caption text--secondary">Elevasi</div>
            <div>
              8
              <span class="text-caption text--secondary">m</span>
            </div>
          </div>
          <div class="text-truncate">
            <div class="text-caption text--secondary">Gradien</div>
            <div>
              0
              <span class="text-caption text--secondary">%</span>
            </div>
          </div>
        </div>
      </div>
      <TodayTable ref="leaderboardTable" style="margin-top: -5px" />
    
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import moment from "moment";
import TodayTable from "./components/TodayTable";
export default {
  name: "App",

  components: {
    TodayTable,
  },

  data() {
    return {
      date: null,
      listTanggal: [],
    };
  },
  computed: {
    
  },
  methods: {
    onDateChange() {
      let vm = this;

      this.$gtag.event(vm.date, {
        event_category: "select",
      });
      vm.$refs.leaderboardTable.date = vm.date;
      vm.$refs.leaderboardTable.getData(vm.date);
    }
  },
  mounted() {
    let vm = this;
    let timeStamp = new Date().getTime();
    let segmentId = "22916066";
    axios
      .get(
        "https://strava-leaderboard.s3.ap-southeast-1.amazonaws.com/leaderboard-list_"+ segmentId +".json?t=" +
        timeStamp
      )
      .then((response) => {
        vm.listTanggal = response.data;

        vm.listTanggal.forEach(tgl => {
          
          var day = moment(tgl.DateId).day();
          if(day == 4){
            tgl.IsRace = true;
          }
        });
        vm.date = vm.listTanggal[0].Id;
        vm.$refs.leaderboardTable.date = vm.date;
        vm.$refs.leaderboardTable.getData(vm.date);
      });
  },
};
</script>

<style lang="scss">
@import "./assets/css/site.scss";
</style>